//
//
//
//
//
//
//
//
//
//
//
//
//

import { controlTopButton } from '@/util/const'

export default {
  created () {
    console.log('created')
    let obj = {
      backVisible: false,
      right1icon: 'btn_ol_close',
      right1link: 'cmcchkh5action://close'
    }
    controlTopButton(obj)
  },
  methods: {
    detail () {
      location.href = 'openpage://1211'
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/easter/success.vue